import React, { useEffect, useState } from "react";
import axios from '../utils/api';
import '../styles/ScheduleEmails.css';

const ScheduledEmails = () => {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEmails = async () => {
      try {
        setLoading(true);
        const response = await axios.get("auth/scheduled_emails/");
        setEmails(response.data);
      } catch (error) {
        console.error("Error fetching scheduled emails", error);
      } finally {
        setLoading(false);
      }
    };
    fetchEmails();
  }, []);

  const getStatusBadgeClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'pending':
        return 'status-pending';
      case 'sent':
        return 'status-sent';
      case 'failed':
        return 'status-failed';
      default:
        return 'status-pending';
    }
  };

  if (loading) {
    return (
      <div className="schedule-page">
        <div className="loading-state">
          <span className="spinner-border"></span>
          <p>Loading scheduled emails...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="schedule-page">
      <div className="page-header">
        <div>
          <h1>Scheduled Emails</h1>
          <p>View and manage all your scheduled email broadcasts</p>
        </div>
        <div className="schedule-count">
          <span className="count-number">{emails.length}</span>
          <span className="count-label">Total Scheduled</span>
        </div>
      </div>

      {emails.length === 0 ? (
        <div className="empty-state">
          <i className="fas fa-calendar-times"></i>
          <h3>No Scheduled Emails</h3>
          <p>You don't have any scheduled email broadcasts yet</p>
        </div>
      ) : (
        <div className="emails-grid">
          {emails.map((email) => (
            <div key={email.id} className="email-card">
              <div className="email-header">
                <div className="email-meta">
                  <h3 className="email-subject">{email.subject}</h3>
                  <p className="email-sol">Solicitation: {email.sol_number}</p>
                </div>
                <span className={`status-badge ${getStatusBadgeClass(email.status)}`}>
                  {email.status}
                </span>
              </div>

              <div className="email-details">
                <div className="detail-row">
                  <i className="fas fa-user"></i>
                  <div>
                    <strong>Creator:</strong> {email.full_name}
                    <br />
                    <span className="email-address">{email.user_email}</span>
                  </div>
                </div>

                <div className="detail-row">
                  <i className="fas fa-clock"></i>
                  <div>
                    <strong>Scheduled For:</strong>
                    <br />
                    {new Date(email.scheduled_time).toLocaleString()}
                  </div>
                </div>

                <div className="detail-row">
                  <i className="fas fa-users"></i>
                  <div>
                    <strong>Recipients ({email.recipients?.length || 0}):</strong>
                    <div className="recipients-tags">
                      {email.recipients?.slice(0, 3).map((recipient, idx) => (
                        <span key={idx} className="recipient-tag">{recipient}</span>
                      ))}
                      {email.recipients?.length > 3 && (
                        <span className="recipient-tag">+{email.recipients.length - 3} more</span>
                      )}
                    </div>
                  </div>
                </div>

                {email.attachment_names && email.attachment_names.length > 0 && (
                  <div className="detail-row">
                    <i className="fas fa-paperclip"></i>
                    <div>
                      <strong>Attachments:</strong>
                      <div className="attachments-list">
                        {email.attachment_names.map((att, idx) => (
                          <span key={idx} className="attachment-tag">{att}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ScheduledEmails;
